import React from "react";
import { HORAS_MAXIMAS_DURACION, UNIDADES_DURACION } from "./duracionTemporalUtils";

export default function DuracionTemporal({ cantidad, unidad, onCantidadChange, onUnidadChange, disabled, opcional = false }) {
  const clase = "min-w-0 border border-gray-600/60 rounded-lg px-3 py-2 bg-neutral-900 text-white";
  return <div>
    <div className="flex gap-2">
      <input type="number" min="1" max={Math.floor(HORAS_MAXIMAS_DURACION / UNIDADES_DURACION[unidad])} step="1"
        aria-label="Cantidad de duración" placeholder={opcional ? "Sin cambio" : "Cantidad"}
        className={`${clase} w-28 flex-1`} value={cantidad} disabled={disabled}
        onChange={e => onCantidadChange(e.target.value)} />
      <select aria-label="Unidad de duración" className={clase} value={unidad}
        disabled={disabled} onChange={e => onUnidadChange(e.target.value)}>
        <option value="horas">Horas</option><option value="dias">Días</option><option value="meses">Meses</option><option value="anios">Años</option>
      </select>
    </div>
    <p className="text-xs text-neutral-400 mt-1">Máximo 10 años. 1 día = 24 horas; mes = 30 días; año = 365 días.</p>
    {opcional && <p className="text-xs text-neutral-400 mt-1">La duración cuenta desde guardar. Vacío conserva la fecha indicada.</p>}
  </div>;
}
